angular.module('lsnBase.deprecated.models')
  .factory('BonusMalusObjectModel', ['LsnBonusMalusObjectModelV1',
    function(LsnBonusMalusObjectModelV1) {
      return LsnBonusMalusObjectModelV1;
    }
  ]);